var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24.549,
    viewBox: "0 0 24 24.549",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Received Order",
    id: "Received_Order",
    transform: "translate(-16297 4804.274)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24.549,
    id: "Back",
    transform: "translate(16297 -4804.274)",
    width: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "delivery_8377835",
    transform: "translate(16073.533 -4900.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.864,101.838a6.128,6.128,0,0,1,8.625-2.5l-1.264,1.264a4.416,4.416,0,0,0-6.146,2.828v.124h-.032a4.415,4.415,0,1,0,8.452-.441l-3.49,3.491a.856.856,0,0,1-1.212,0l-2.349-2.349a.856.856,0,0,1,1.211-1.212l1.743,1.744,4.563-4.563a.856.856,0,1,1,1.211,1.212l-.377.377a6.129,6.129,0,0,1-4.485,8.831v5.8a2.568,2.568,0,0,1-2.569,2.569H226.035a2.568,2.568,0,0,1-2.569-2.569V104.406a2.57,2.57,0,0,1,2.569-2.569Zm-8.14,1.712h-1.688a.856.856,0,0,0-.856.856v12.036a.857.857,0,0,0,.856.856h13.711a.856.856,0,0,0,.856-.856v-5.768a6.087,6.087,0,0,1-2.581-.932v2.348a.856.856,0,0,1-1.326.716l-3.823-2.51-3.823,2.51a.856.856,0,0,1-1.326-.716Zm7.576,0h-5.863V110.5l2.967-1.948a.856.856,0,0,1,.94,0l2.967,1.948v-2.414a6.135,6.135,0,0,1-1.01-4.54Z",
    "data-name": "Path 8332",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8332"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconReceived);
export default __webpack_public_path__ + "static/media/status_icon_received.23191b2460096c326778ed533674c675.svg";
export { ForwardRef as ReactComponent };